import { ReactNode } from 'react';

import s from './Chip.module.css';

type ChipProps = {
  children: ReactNode;
};

const Chip = ({ children }: ChipProps) => {
  return <span className={s.chip}>{children}</span>;
};

export default Chip;
